package dairy.mynotes.firebase

import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.firestore.FirebaseFirestore

/**
 * JS actual — holds the single Auth and Firestore instances
 * that are set once during main() BEFORE any repository is used.
 * This prevents "initializeFirestore() called with different options" errors.
 */
actual object FirebaseService {
    private var _auth: FirebaseAuth? = null
    private var _firestore: FirebaseFirestore? = null

    fun initialize(auth: FirebaseAuth, firestore: FirebaseFirestore) {
        _auth = auth
        _firestore = firestore
    }

    actual val auth: FirebaseAuth
        get() = _auth ?: error("FirebaseService not initialized. Call FirebaseService.initialize() in main().")

    actual val firestore: FirebaseFirestore
        get() = _firestore ?: error("FirebaseService not initialized. Call FirebaseService.initialize() in main().")
}

